import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "../dashboard/Title";

import Grid from "@mui/material/Grid";
import { selectCurrentUser, useDeleteUserMutation } from "../../store";
import { UserRow } from "./UserRow";
import { User } from "../../store/apis/usersApi";
import { useEffect, useState } from "react";
import { SuccessErrorToast } from "../utils/SuccessErrorToast";
import { useAppSelector } from "../../hooks/hooks";

export default function Users() {
  const [deleteUser, deleteResult] = useDeleteUserMutation();

  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const [successDeleteOpen, setSuccessDeleteOpen] = useState(false);
  const [errorDeleteOpen, setErrorDeleteOpen] = useState(false);

  const currentUser = useAppSelector(selectCurrentUser);
  const data: User[] = [];
  if (currentUser) {
    data.push({ ...currentUser });
  }

  useEffect(() => {
    if (deleteResult.isSuccess) {
      setSuccessDeleteOpen(true);
    }
    if (deleteResult.isError) {
      setErrorDeleteOpen(true);
    }
  }, [deleteResult]);

  return (
    <React.Fragment>
      <SuccessErrorToast
        successOpen={successOpen}
        errorOpen={errorOpen}
        successMessage="Käyttäjä lisätty onnistuneesti!"
        errormessage="Käyttäjän lisääminen epäonnistui!"
        setSuccessOpen={setSuccessOpen}
        setErrorOpen={setErrorOpen}
      />
      <SuccessErrorToast
        successOpen={successDeleteOpen}
        errorOpen={errorDeleteOpen}
        successMessage="Käyttäjä poistettu onnistuneesti!"
        errormessage="Käyttäjän poistaminen epäonnistui!"
        setSuccessOpen={setSuccessDeleteOpen}
        setErrorOpen={setErrorDeleteOpen}
      />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title>Käyttäjätili</Title>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Nimi</TableCell>
                <TableCell>Sähköposti</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.map(user => (
                  <UserRow user={user} key={user.id} deleteUser={deleteUser} />
                ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
